import { MenuList, MenuSection } from "../components/menu";
import DownloadAppButton from "./download-app-button";
import { useInstall } from "./install/install-state";
import TransferButton from "./session-transfer/transfer-button";

const AppMenu = ({ showTransfer, onTransfer, onInstall }) => {
  const { method } = useInstall();
  if (!showTransfer && !method) return null;
  return (
    <MenuSection title="App" className="app-menu">
      <MenuList>
        {showTransfer && <TransferButton onClick={onTransfer} />}
        <DownloadAppButton onOpen={onInstall} />
      </MenuList>
    </MenuSection>
  );
};

export default AppMenu;
